import { ClientItem } from 'owa-mail-store';
import { action } from 'satcheljs';

export default action('updateItemLanguageAction', function(item: ClientItem) {
    return {
        item: item,
    };
});
